module.exports = __webpack_public_path__ + "img/15.485e87d5.webp";